const urlCorfoUDD = 'http://wapp4.corfo.cl/GIN/ActualizacionCentrosID/Views/publico/centro.aspx?centro=SR-171&area=null'
const urlCorfoUNAB = 'http://wapp4.corfo.cl/GIN/ActualizacionCentrosID/Views/publico/centro.aspx?centro=SR-092&area=null'
export const centros_corfo = [
    {
        nombre: 'Programa de Genómica Microbiana',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Programa Inmunología Traslacional',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Programa de Estudios Sociales en Salud',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Centro de Epidemiología y Políticas de Salud',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Observatorio de Bioética',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Centro De Fisiología Celular E Integrativa',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Centro de Bioética',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Centro de Genética y Genómica',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Centro de Informática Biomedica',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Centro de Estudios Clínicos',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Centro de Química Médica',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Centro De Medicina Regenerativa',
        universidad: 'UDD',
        url: urlCorfoUDD
    },
    {
        nombre: 'Centro De Biotecnología Vegetal',
        universidad: 'UNAB',
        url: urlCorfoUNAB
    }
]